module.exports = __webpack_public_path__ + "img/consent-collection-widget-bottom-left.776fd98b.svg";